/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { IInstagramIntegrationData } from './instagram-integration.data';
import { IInstagramIntegrationProps } from './instagram-integration.props.autogenerated';
export interface IInstagramIntegrationViewProps extends IInstagramIntegrationProps<IInstagramIntegrationData> { }

/**
 *
 * InstagramIntegration component
 * @extends {React.Component<IInstagramIntegrationProps<IInstagramIntegrationData>>}
 */
@observer
class InstagramIntegration extends React.Component<IInstagramIntegrationProps<{}>> {

    @observable public _scriptLoaded: boolean = false;
    private _scriptSrc: string = 'https://us-display.wayin.com/ui/ngx.embed.min.js';

    public constructor(props: IInstagramIntegrationProps<{}>) {
        super(props);
    }

    public componentDidMount(): void {
        if (!this._isScriptLoaded) {
            this._injectScript();
        }
    }

    public render(): JSX.Element {
        if (this._scriptLoaded) {
            return this.props.renderView(this.props) || <div />;
        }
        return <div />;
    }

    private _injectScript(): void {
        const script = document.createElement('script');

        script.onload = () => { this._scriptLoaded = true; };
        script.src = 'https://us-display.wayin.com/ui/ngx.embed.min.js';

        document.head.appendChild(script);
    }

    private get _isScriptLoaded(): boolean {
        return !!document.querySelector(`script[src='${this._scriptSrc}']`);
    }
}

export default InstagramIntegration;
